<h2 class="mat-h2">{{ project.name }} used in patients</h2>
<div echarts [options]="options"></div>
